/**
 * Управление виджетами рейтинга (звёзды для постов, лайки/дизлайки для комментариев)
 * Поддерживает делегирование событий для работы с динамически загружаемым контентом
 */
document.addEventListener('DOMContentLoaded', function() {
    
    // Инициализация состояния проголосованных элементов для уже существующих на странице
    initVotedState();
    
    // Делегирование событий - один обработчик для всех кликов (работает для динамического контента)
    document.body.addEventListener('click', function(event) {
        
        // Обработка рейтинга постов (звёзды)
        if (event.target.closest('.saborlista-post-rating .star-btn')) {
            handlePostRating(event);
        }
        
        // Обработка рейтинга комментариев (лайки/дизлайки)
        if (event.target.closest('.saborlista-comment-rating .like-btn, .saborlista-comment-rating .dislike-btn')) {
            handleCommentRating(event);
        }
    });

    // --- Автономная инициализация новых элементов через MutationObserver ---
    const contentContainer = document.querySelector('#main, .site-main, main');
    if (contentContainer) {
        const mutationObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { 
                            // Если в добавленном узле есть элементы рейтинга, обновляем их состояние
                            const hasRatings = node.querySelector('.saborlista-post-rating, .saborlista-comment-rating');
                            if (hasRatings || node.classList.contains('saborlista-post-rating') || node.classList.contains('saborlista-comment-rating')) {
                                initVotedState();
                            }
                        }
                    });
                }
            }
        });
        mutationObserver.observe(contentContainer, { childList: true, subtree: true });
    }
    
    // Сохраняем поддержку кастомного события для обратной совместимости
    document.body.addEventListener('content-loaded', initVotedState);
    
    /**
     * Инициализация состояния проголосованных элементов
     */
    function initVotedState() {
        // Получение данных из sessionStorage
        const votedPosts = JSON.parse(sessionStorage.getItem('saborlista_voted_posts') || '[]');
        const votedComments = JSON.parse(sessionStorage.getItem('saborlista_voted_comments') || '[]');
        
        // Обновление состояния рейтингов постов
        document.querySelectorAll('.saborlista-post-rating').forEach(element => {
            const postId = element.getAttribute('data-post-id');
            if (postId && votedPosts.includes(postId)) {
                element.classList.add('is-voted');
            }
        });
        
        // Обновление состояния рейтингов комментариев
        document.querySelectorAll('.saborlista-comment-rating').forEach(element => {
            const commentId = element.getAttribute('data-comment-id');
            if (commentId && votedComments.includes(commentId)) {
                element.classList.add('is-voted');
            }
        });
    }
    
    /**
     * Обработка клика по звёздам рейтинга поста
     */
    function handlePostRating(event) {
        const clickedButton = event.target.closest('.star-btn');
        const ratingContainer = event.target.closest('.saborlista-post-rating');
        
        // Проверка на уже проголосованные или загружающиеся элементы
        if (ratingContainer.classList.contains('is-voted') || ratingContainer.classList.contains('is-loading')) {
            return;
        }
        
        // Получение данных
        const postId = ratingContainer.getAttribute('data-post-id');
        const rating = clickedButton.getAttribute('data-rating');
        
        if (!postId || !rating) {
            console.error(saborlistaSingle.i18n.ratingRequiredData);
            return;
        }
        
        // Оптимистичное обновление UI
        ratingContainer.classList.add('is-loading', 'is-voted');
        updateStarsUI(ratingContainer, rating);
        
        // AJAX-запрос
        const formData = new FormData();
        formData.append('action', 'handle_post_rating');
        formData.append('post_id', postId);
        formData.append('rating', rating);
        formData.append('nonce', saborlistaAjax.nonce);
        
        fetch(saborlistaAjax.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Сохранение в sessionStorage
                const votedPosts = JSON.parse(sessionStorage.getItem('saborlista_voted_posts') || '[]');
                if (!votedPosts.includes(postId)) {
                    votedPosts.push(postId);
                    sessionStorage.setItem('saborlista_voted_posts', JSON.stringify(votedPosts));
                }
                
                // Обновление текстовых полей с данными от сервера
                updatePostRatingText(ratingContainer, data.data.new_count, data.data.new_average);
                ratingContainer.classList.remove('is-loading');

                // Send analytics event
                if (window.SaborlistaAnalytics) {
                    window.SaborlistaAnalytics.sendEvent('post_rating', {
                        rating: rating,
                        post_id: postId,
                        new_average: data.data.new_average,
                        new_count: data.data.new_count
                    });
                }

                if (window.SaborlistaNotifications) {
                    const successMsg = data.data.message || (window.saborlistaSingle && window.saborlistaSingle.i18n && window.saborlistaSingle.i18n.ratingVoteAccepted) || 'Vote accepted!';
                    window.SaborlistaNotifications.success(successMsg);
                }
            } else {
                // Ошибка - откат UI
                const errorMsg = data.data?.message || saborlistaSingle.i18n.ratingUnknownError;
                console.error(saborlistaSingle.i18n.ratingError, errorMsg);
                rollbackPostRatingUI(ratingContainer);
                
                if (window.SaborlistaNotifications) {
                    window.SaborlistaNotifications.error(errorMsg);
                }
            }
        })
        .catch(error => {
            // Ошибка сети - откат UI
            console.error(saborlistaSingle.i18n.ratingNetworkError, error);
            rollbackPostRatingUI(ratingContainer);

            if (window.SaborlistaNotifications) {
                window.SaborlistaNotifications.error(saborlistaSingle.i18n.ratingNetworkError || 'Network error');
            }
        });
    }
    
    /**
     * Обработка клика по лайкам/дизлайкам комментария
     */
    function handleCommentRating(event) {
        const clickedButton = event.target.closest('.like-btn, .dislike-btn');
        const ratingContainer = event.target.closest('.saborlista-comment-rating');
        
        // Проверка на уже проголосованные или загружающиеся элементы
        if (ratingContainer.classList.contains('is-voted') || ratingContainer.classList.contains('is-loading')) {
            return;
        }
        
        // Получение данных
        const commentId = ratingContainer.getAttribute('data-comment-id');
        const action = clickedButton.getAttribute('data-action');
        
        if (!commentId || !action) {
            console.error(saborlistaSingle.i18n.ratingRequiredData);
            return;
        }
        
        // Оптимистичное обновление UI
        ratingContainer.classList.add('is-loading', 'is-voted');
        updateCommentCountersUI(ratingContainer, action);
        
        // AJAX-запрос
        const formData = new FormData();
        formData.append('action', 'handle_comment_rating');
        formData.append('comment_id', commentId);
        formData.append('rating_action', action);
        formData.append('nonce', saborlistaAjax.nonce);
        
        fetch(saborlistaAjax.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Сохранение в sessionStorage
                const votedComments = JSON.parse(sessionStorage.getItem('saborlista_voted_comments') || '[]');
                if (!votedComments.includes(commentId)) {
                    votedComments.push(commentId);
                    sessionStorage.setItem('saborlista_voted_comments', JSON.stringify(votedComments));
                }
                
                // Обновление счётчиков точными данными от сервера
                updateCommentCountersText(ratingContainer, data.data.new_likes, data.data.new_dislikes);
                ratingContainer.classList.remove('is-loading');

                // Send analytics event
                if (window.SaborlistaAnalytics) {
                    window.SaborlistaAnalytics.sendEvent('comment_vote', {
                        vote_type: action, // 'like' or 'dislike'
                        comment_id: commentId,
                        new_likes: data.data.new_likes,
                        new_dislikes: data.data.new_dislikes
                    });
                }

                if (window.SaborlistaNotifications) {
                    const successMsg = data.data.message || (window.saborlistaSingle && window.saborlistaSingle.i18n && window.saborlistaSingle.i18n.ratingVoteAccepted) || 'Vote accepted!';
                    window.SaborlistaNotifications.success(successMsg);
                }
            } else {
                // Ошибка - откат UI
                const errorMsg = data.data?.message || saborlistaSingle.i18n.ratingUnknownError;
                console.error(saborlistaSingle.i18n.ratingError, errorMsg);
                rollbackCommentRatingUI(ratingContainer);

                if (window.SaborlistaNotifications) {
                    window.SaborlistaNotifications.error(errorMsg);
                }
            }
        })
        .catch(error => {
            // Ошибка сети - откат UI
            console.error(saborlistaSingle.i18n.ratingNetworkError, error);
            rollbackCommentRatingUI(ratingContainer);

            if (window.SaborlistaNotifications) {
                window.SaborlistaNotifications.error(saborlistaSingle.i18n.ratingNetworkError || 'Network error');
            }
        });
    }
    
    /**
     * Обновление UI звёзд (добавление класса is-active)
     */
    function updateStarsUI(container, rating) {
        const starButtons = container.querySelectorAll('.star-btn');
        starButtons.forEach((button, index) => {
            const icon = button.querySelector('i.sb');
            const starIndex = index + 1;
            if (starIndex <= rating) {
                button.classList.add('is-active');
                if (icon) {
                    icon.classList.remove('sb-star-o');
                    icon.classList.remove('sb-star-half-o');
                    icon.classList.add('sb-star');
                }
            } else {
                button.classList.remove('is-active');
                if (icon) {
                    icon.classList.remove('sb-star');
                    icon.classList.remove('sb-star-half-o');
                    icon.classList.add('sb-star-o');
                }
            }
        });
    }
    
    /**
     * Обновление текстовых полей рейтинга поста
     */
    function updatePostRatingText(container, newCount, newAverage) {
        const ratingText = container.querySelector('.rating-text');
        if (ratingText) {
            // Формирование нового текста (аналогично PHP-коду)
            const votesText = newCount === 1 ? saborlistaSingle.i18n.vote : saborlistaSingle.i18n.votes;
            const text = `${saborlistaSingle.i18n.ratingText} ${newAverage} ${saborlistaSingle.i18n.ratingOutOf} 5 (${newCount} ${votesText})`;
            ratingText.textContent = text;
        }
    }
    
    /**
     * Оптимистичное обновление счётчиков комментариев
     */
    function updateCommentCountersUI(container, action) {
        if (action === 'like') {
            const likesCount = container.querySelector('.likes-count');
            if (likesCount) {
                const currentCount = parseInt(likesCount.textContent) || 0;
                likesCount.textContent = currentCount + 1;
            }
        } else if (action === 'dislike') {
            const dislikesCount = container.querySelector('.dislikes-count');
            if (dislikesCount) {
                const currentCount = parseInt(dislikesCount.textContent) || 0;
                dislikesCount.textContent = currentCount + 1;
            }
        }
    }
    
    /**
     * Обновление счётчиков комментариев точными данными от сервера
     */
    function updateCommentCountersText(container, newLikes, newDislikes) {
        const likesCount = container.querySelector('.likes-count');
        const dislikesCount = container.querySelector('.dislikes-count');
        
        if (likesCount) {
            likesCount.textContent = newLikes;
        }
        if (dislikesCount) {
            dislikesCount.textContent = newDislikes;
        }
    }
    
    /**
     * Откат UI рейтинга поста в исходное состояние
     */
    function rollbackPostRatingUI(container) {
        container.classList.remove('is-loading', 'is-voted');
        
        // Убираем активные звёзды
        const starButtons = container.querySelectorAll('.star-btn');
        starButtons.forEach(button => {
            button.classList.remove('is-active');
        });
    }
    
    /**
     * Откат UI рейтинга комментария в исходное состояние
     */
    function rollbackCommentRatingUI(container) {
        container.classList.remove('is-loading', 'is-voted');
        
        // Восстанавливаем исходные значения счётчиков
        // (в реальном проекте здесь можно сохранить исходные значения)
        // Для простоты оставляем текущие значения
    }
});
